import { UIEvent } from 'react';
import { app } from 'core';
import { ButtonSolid } from 'ui/components';
import { ProductsComponents } from './Products.components.styles';
import { useIsAutoStartEnabled, useIsResaleIntention } from 'core/use-cases/user/selectors';
import type { Catalog } from 'core';

export const ComboButton = ({
  name,
  onClick,
  productCode,
  ...props
}: Partial<Catalog['data'][number]> & { onClick?: () => void }) => {
  const { trackClick } = app.commands.useAppCommand();
  const isResaleIntention = useIsResaleIntention();
  const isAutoStartEnabled = useIsAutoStartEnabled();

  const comboClick = (event: UIEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick();
    }

    trackClick(event, 'event', {
      eventAction: 'clique:botao',
      eventCategory: 'combo-personalizado',
      eventLabel: `monte-seu-combo:${name}`,
    });
  };

  return (
    <ProductsComponents.ButtonCombo target="_self" to={`/combo?q=${productCode}`}>
      <ButtonSolid
        onClick={comboClick}
        stretch
        disabled={isResaleIntention && !isAutoStartEnabled}
        tabIndex={0}
        aria-label={`montar combo de ${name}`}
        {...props}
      >
        Montar combo
      </ButtonSolid>
    </ProductsComponents.ButtonCombo>
  );
};
